import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyAls0k1-SUegOeOuVgJN54x3nK_hwDqPIs",
    authDomain: "hareshima-22985.firebaseapp.com",
    projectId: "hareshima-22985",
    storageBucket: "hareshima-22985.firebasestorage.app",
    messagingSenderId: "571647772894",
    appId: "1:571647772894:web:1f4fb432e8b4c1803d5a4f"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

export default app;
